import React, { useRef, useEffect } from 'react';

interface SearchBarProps {
  query: string;
  onChange: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ query, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <div className="flex-1 max-w-md">
      <input
        ref={inputRef}
        className="w-full px-2 py-1 border border-gray-300 bg-transparent text-sm outline-none"
        placeholder="Search links, folders, tags..."
        value={query}
        onChange={(e) => onChange(e.target.value)}
        dir="rtl"
      />
    </div>
  );
};

export default SearchBar;